<div class="novo-campanha-multiselect">
  <sgt-multi-select-grouped
    #multiSelectRef
    [settings]="settings"
    [options]="groups"
    [variante]="variante"
    [(ngModel)]="idsCampanhas"
    (ngModelChange)="onSelectionChange()"
    (isFirstOpened)="firstOpened($event)"
    (hasOpened)="onHasOpened($event)"
    (search)="onSearch()">

    <span input-prefix class="novo-campanha-multiselect__filter-icon" (click)="$event.stopPropagation()">
      <sgt-menu
        #menuRef
        [settings]="{ closeOnSelect: false }"
        (opened)="onMenuOpened()">
        <span trigger class="novo-campanha-multiselect__gear-trigger">
          <i class="fas fa-sliders-h"></i>
        </span>
        <div items class="novo-campanha-multiselect__menu-item">
          <label class="custom-control custom-switch mb-0">
            <input
              type="checkbox"
              class="custom-control-input"
              [(ngModel)]="somenteEmAndamento"
              (ngModelChange)="onSomenteEmAndamentoChange()"
            />
            <span class="custom-control-label">Somente Em Andamento</span>
          </label>
        </div>
      </sgt-menu>
    </span>

  </sgt-multi-select-grouped>
</div>
